export default [
  {
    title: "Lantern Loft",
    tag: "solo project",
    description:
      "A Laravel + Vue 3 ecommerce platform showcasing clean architecture, type-safe frontend design, and a generated static demo for GitHub Pages deployment.",
    about: [
      "Vue",
      "Composition API",
      "Pinia",
      "TypeScript",
      "Tailwind",
      "Axios",
      "PHP",
      "Laravel"
    ],
    links: {
      live: "https://allankirui.github.io/lantern-loft",
      repo: "https://github.com/AllanKirui/lantern-loft"
    },
    img: "10-lantern-loft.png",
    isCollab: false
  },
  {
    title: "Brain Bender",
    tag: "solo project",
    description:
      "Built an interactive Sudoku application to strengthen my understanding of React and TypeScript.",
    about: ["React", "TypeScript", "Tailwind"],
    links: {
      live: "https://allankirui.github.io/brain-bender",
      repo: "https://github.com/AllanKirui/brain-bender"
    },
    img: "9-brain-bender.png",
    isCollab: false
  },
  {
    title: "Calculate It",
    tag: "solo project",
    description:
      "Having built previous Vue apps using the Options API, I wanted to gain hands-on experience with the Composition API. From concept to code, creating this calculator app with Vue's Composition API was a rewarding journey.",
    about: ["Vue", "Composition API", "Tailwind"],
    links: {
      live: "https://allankirui.github.io/calculate-it",
      repo: "https://github.com/AllanKirui/calculate-it"
    },
    img: "8-calculate-it.png",
    isCollab: false
  },
  {
    title: "Your Notes v2",
    tag: "solo project",
    description:
      "An updated version of a notes app I had created with vanilla JavaScript. It features a better UI/UX flow compared to the earlier version and intergrates with Firebase to facilitate user authentication and persistance of user data across devices.",
    about: ["Vue", "Vuex", "Options API", "Firebase"],
    links: {
      live: "https://allankirui.github.io/your-notes-v2",
      repo: "https://github.com/AllanKirui/your-notes-v2"
    },
    img: "1-yournotes-v2.png",
    isCollab: false
  },
  {
    title: "Vue Movies",
    tag: "solo project",
    description:
      "A movie database I designed to get some practice with the topics I was learning about Vue at the time. The site gives users suggestions for movies and TV shows in either the popular or top rated categories. Users can also perform searches based these two categories.",
    about: ["Vue", "Options API", "Routing", "API Integration"],
    links: {
      live: "https://allankirui.github.io/vue-movies",
      repo: "https://github.com/AllanKirui/vue-movies"
    },
    img: "2-vue-movies.png",
    isCollab: false
  },
  {
    title: "The Frontend",
    tag: "solo project",
    description:
      "A project I designed in the format of a newspaper as a refresher on CSS Grid. As part of the 'headlines', the page lists some useful resources about programming in general.",
    about: ["HTML", "SASS", "CSS Grid", "JavaScript"],
    links: {
      live: "https://allankirui.github.io/the-frontend",
      repo: "https://github.com/AllanKirui/the-frontend"
    },
    img: "3-the-frontend.png",
    isCollab: false
  },
  {
    title: "Vue Color Picker",
    tag: "solo project",
    description:
      "A project I created earlier on when I was learning the basics of Vue. The goal of the project was to get some practice with creating components and to better understand how components communicate with each other.",
    about: ["Vue", "Components", "Options API"],
    links: {
      live: "https://allankirui.github.io/vue-color-picker",
      repo: "https://github.com/AllanKirui/vue-color-picker"
    },
    img: "4-color-picker.png",
    isCollab: false
  },
  {
    title: "Social Proof",
    tag: "a collaborative project",
    description:
      "My first collaborative project. I met an amazing human being on Frontend Mentor and we decided to work together on one of the simpler challenges offered by the site.",
    about: ["HTML", "CSS", "Git", "GitHub", "Collaboration"],
    links: {
      live: "https://practical-tereshkova-8c641d.netlify.app/",
      repo: "https://github.com/AllanKirui/social-proof"
    },
    img: "5-social-proof.png",
    isCollab: true
  },
  {
    title: "Loopstudios",
    tag: "a collaborative project",
    description:
      "A second collaborative project. After successfully finishing out Social Proof Frontend Mentor challenge, my collaboration partner and I decided to work on another project - a slightly bigger Frontend Mentor challenge.",
    about: ["HTML", "CSS", "Git", "GitHub", "Collaboration"],
    links: {
      live: "https://hungry-kilby-fc41c0.netlify.app/",
      repo: "https://github.com/AllanKirui/loopstudios-landing-page"
    },
    img: "6-loopstudios.png",
    isCollab: true
  },
  {
    title:
      "Learning to Code on a 12 Year Old Machine - A Journey of Patience and Perseverance",
    tag: null,
    description:
      "I blog about my journey as a self-taught developer and the challenges I've faced while learning how to code.",
    about: ["Grit", "Humor"],
    links: {
      live: "https://allankirui.github.io/my-journey",
      repo: null
    },
    img: "7-blog.png",
    isCollab: false
  }
]
